module.exports = __webpack_public_path__ + "static/img/banner1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/banner1.png
// module id = 538
// module chunks = 0